import { Component, OnInit } from '@angular/core';
import { TwilioService } from './twilio.service';
import { User } from './user';
import { RouterOutlet } from '@angular/router';
import { MobileNavbarComponent } from './mobile-navbar/mobile-navbar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { IncomingCallDialogComponent } from './incoming-call-dialog/incoming-call-dialog.component';
import { InCallDialogComponent } from './in-call-dialog/in-call-dialog.component';
import { NotificationBannerComponent } from './notification-banner/notification-banner.component';
import { NotificationContainerComponent } from './notification-container/notification-container.component';
import { AlertComponent } from './alert/alert.component';
import { CloningNotificationBannerComponent } from "./cloning-notification-banner/cloning-notification-banner.component";

@Component({
    selector: 'app-app2',
    templateUrl: './app2.component.html',
    styleUrls: ['./app2.component.css'],
    imports: [AlertComponent, NotificationContainerComponent, NotificationBannerComponent, InCallDialogComponent, IncomingCallDialogComponent, NavbarComponent, MobileNavbarComponent, RouterOutlet, CloningNotificationBannerComponent]
})
export class App2Component implements OnInit {

  constructor(
    private twilioService: TwilioService) { }

  ngOnInit(): void {
    const loginDetails:User = JSON.parse(localStorage.getItem('login'))
    if(loginDetails && loginDetails.twilioSID && loginDetails.isBeta && loginDetails.defaultNumber){
      this.twilioService.connectTwilio();
    }
  }
}
